class TimeoutError extends Error {
  constructor(ms) {
    super(`API call timed out after ${ms}ms`);
    this.name = "TimeoutError";
    this.timeoutMs = ms;
  }
}

export default TimeoutError;